import { Navigate } from "react-router";
import logo from "../assets/logo.svg";
import { useMe } from "../api/hooks";
import { Panel, Spinner } from "../components/ui";

export function LoginPage() {
  const me = useMe();
  if (me.isPending) return <div className="p-8"><Spinner /></div>;
  if (me.data) return <Navigate to="/" replace />;
  return (
    <main className="flex min-h-screen items-center justify-center bg-hs-surface-alt p-4">
      <Panel className="w-full max-w-sm text-center">
        <img src={logo} alt="Hello Sugar" className="mx-auto h-[72px] w-auto" />
        <h1 className="mt-4 text-xl font-semibold text-hs-text">Block-til-Busy Manager</h1>
        <p className="mt-2 text-[13px] text-hs-text-muted">Automatic BTB blocks at the start and end of shifts, for the locations you own.</p>
        <a href="/auth/google" className="mt-6 inline-flex h-10 w-full items-center justify-center rounded-full bg-hs-primary-strong px-4 text-sm font-semibold text-hs-on-primary hover:brightness-90">
          Sign in with Google
        </a>
        <p className="mt-3 text-xs text-hs-text-muted">Use the Google account your locations' contact email belongs to.</p>
      </Panel>
    </main>
  );
}
